import React, { useState, useRef, useEffect } from "react";
import bot from "./Images/bot.svg";
import user from "./Images/user.svg";
import "./index.css";
import send from "./Images/send.svg";
import OrderingExample from "../src/components/Body";
import Button from "react-bootstrap/Button";
import { signInWithRedirect, auth, provider, getRedirectResult, onAuthStateChanged } from "./config/config";

function App() {
  const [chatStripes, setChatStripes] = useState([]);
  const formRef = useRef(null);

  const loader = (element) => {
    element.textContent = "";

    const loadInterval = setInterval(() => {
      // Update the text content of the loading indicator
      element.textContent += ".";

      // If the loading indicator has reached three dots, reset it
      if (element.textContent === "....") {
        element.textContent = "";
      }
    }, 300);

    return loadInterval;
  };

  const typeText = (element, text) => {
    let index = 0;

    const interval = setInterval(() => {
      if (index < text.length) {
        element.innerHTML += text.charAt(index);
        index++;
      } else {
        clearInterval(interval);
      }
    }, 20);
  };

  const generateUniqueId = () => {
    const timestamp = Date.now();
    const randomNumber = Math.random();
    const hexadecimalString = randomNumber.toString(16);

    return `id-${timestamp}-${hexadecimalString}`;
  };

  const chatStripe = (isAi, value, uniqueId) => (
    <div className={`wrapper ${isAi ? "ai" : ""}`}>
      <div className="chat">
        <div className="profile">
          <img src={isAi ? bot : User.photoURL} alt={isAi ? "bot" : "user"} />
        </div>
        <div className="message" id={uniqueId}>
          {value}
        </div>
      </div>
    </div>
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = formRef.current;

    if (!form) return;

    const data = new FormData(form);

    // user's chatstripe
    const prompt = data.get("prompt");
    if (!prompt) return; // Don't submit if prompt is empty

    const newChatStripes = [...chatStripes];

    newChatStripes.push({
      isAi: false,
      value: prompt,
      uniqueId: generateUniqueId()
    });

    setChatStripes(newChatStripes);

    // Clear the input
    form.reset();

    // Scroll to the bottom
    // chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;

    // bot's chatstripe
    const uniqueId = generateUniqueId();

    newChatStripes.push({
      isAi: true,
      value: "...",
      uniqueId
    });

    setChatStripes(newChatStripes);

    setTimeout(() => {
      const messageDiv = document.getElementById(uniqueId);
      const loadInterval = loader(messageDiv);
    
      fetch("https://react-chatbot.onrender.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          prompt: data.get("prompt"),
        }),
      })
        .then((response) => {
          clearInterval(loadInterval);
          messageDiv.innerHTML = "";
    
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Something went wrong");
          }
        })
        .then((data) => {
          const parsedData = data.bot.trim();
          const chatStripesCopy = [...newChatStripes];
    
          chatStripesCopy.find(
            (stripe) => stripe.uniqueId === uniqueId
          ).value = parsedData;
    
          //setChatStripes(chatStripesCopy);
          typeText(messageDiv, parsedData);
          console.log(chatStripesCopy);
        })
        .catch((error) => {
          messageDiv.innerHTML = error.message;
        });
    }, 0);
    
  };


  // const handleScrollClick = () => {
  //   window.scrollTo({
  //     top: document.body.scrollHeight,
  //     behavior: 'smooth' // Optional: Adds smooth scrolling effect
  // });
    
  // };


  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      handleSubmit(e);
    }
  };

  //Firebase logics 

  const signIn = (e) => {
    //alert('signing.....')
    e.preventDefault();
    signInWithRedirect(auth, provider);
  }

  const [signedIn, setSignedIn] = useState(false)
  const [User, setUser] = useState(false)

  //Get result
  useEffect(() => {
    getRedirectResult(auth)
  .then((result) => {
    if(result) {
      setSignedIn(true)
      //console.log(result)
    //console.log(result.user)
    } else {

    }
    // // This gives you a Google Access Token. You can use it to access Google APIs.
    // const credential = GoogleAuthProvider.credentialFromResult(result);
    // const token = credential.accessToken;

    // // The signed-in user info.
    // const user = result.user;
    // // IdP data available using getAdditionalUserInfo(result)
    // ...
  }).catch((error) => {
    console.log(error);
    // // Handle Errors here.
    // const errorCode = error.code;
    // const errorMessage = error.message;
    // // The email of the user's account used.
    // const email = error.customData.email;
    // // The AuthCredential type that was used.
    // const credential = GoogleAuthProvider.credentialFromError(error);
    // // ...
  });
  } ,[])

  //Check if user is logged in
  useEffect(() => {
    //checking if user is logged in
    onAuthStateChanged(auth, (user) => {
      if (user) {
        //setSignedIn(true)
        //console.log(user);
        const {displayName, email, photoURL, uid} = user
        setUser({ displayName, email, photoURL, uid })
        // // User is signed in, see docs for a list of available properties
        // // https://firebase.google.com/docs/reference/js/auth.user
        // const uid = user.uid;
        // ...
      } else {
        setUser(null)
        // User is signed out
        // ...
      }
    });
  } ,[])

  const signOut = (e) => {
    e.preventDefault()
    auth.signOut().then(() => {
      alert('Signed Out')
    })
  }

  return (
    <div id="app">
          {
            User ? 
              <div id="app">
                    <Button onClick={(e) => signOut(e)} className="signOut" >Sign Out</Button>
      <div id="chat_container">
        {/* {isEmpty && <div>You have not made any requests.</div>} */}
        {chatStripes.length === 0 ? (
          <div>
          <OrderingExample />
          </div>
        ) : (
          chatStripes.map((stripe, index) => (
            <div key={index} className={`wrapper ${stripe.isAi ? "ai" : ""}`}>
              <div className="chat">
                <div className="profile">
                  <img
                    src={stripe.isAi ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-dM2zpxlPPSLlkiMJLrsEHc1N1Y2iyNwzjNrLfYN3qdzQliJCEu6VzwqUJGb_aXa9g4Y&usqp=CAU' : User.photoURL}
                    alt={stripe.isAi ? "bot" : "user"}
                  />
                </div>
                <div className="message" id={stripe.uniqueId}>
                  {stripe.value }
                  
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      <form onSubmit={handleSubmit} ref={formRef}>
        <textarea
          className="text-area"
          name="prompt"
          rows="1"
          cols="1"
          placeholder="Ask Me ....."
          onKeyUp={handleKeyUp}
        ></textarea>
        <button type="submit">
          <img
            src={send}
            alt="send"
          />
        </button>
      </form>
              </div>
                :
                <div id="app" style={{display: 'unset', height: 'unset'}}> 
                  <div style={{opacity : '0.2', position: 'relative', zIndex: '0'}}>
                    <OrderingExample />
                  </div>
                  <div className="login-div">
                    <p style={{ color: 'white' }}> You are not signed, kindly sign in first </p>
                    <Button onClick={(e) => signIn(e)} style={{ opacity: '1' }} > Sign In </Button>
                  </div>
                </div>
              }
    </div>
  );
}

export default App;